import { render, staticRenderFns } from "./ResponsibilityAvgReadinessBanner.vue?vue&type=template&id=20c36bc4&scoped=true"
import script from "./ResponsibilityAvgReadinessBanner.vue?vue&type=script&lang=js"
export * from "./ResponsibilityAvgReadinessBanner.vue?vue&type=script&lang=js"
import style0 from "./ResponsibilityAvgReadinessBanner.vue?vue&type=style&index=0&id=20c36bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c36bc4",
  null
  
)

export default component.exports